import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { SiteModel } from "./SiteModel";

export class TaskModel {
    public Id: number;
    public TaskNo: string;
    public Title: string;
    public Purpose: string;
    public Description: String = "";
    public Interval: number;
    public NuberOfDays: number;
    public RemindAfter: number;

    public Status: string;
    public StartDate: Date;
    public EndDate: Date;
    public ExtensionsAllowed: number;
    public DayToComplete: number;
    public RemainingExtensionsAllowed: number;
    public RoleId: number;
    public TaskMainCategory: TaskMainCategoryModel[];
    public TaskSubCategories: TaskSubCategoryModel[];
    public RecommendedRole: string;
    public IsAllowedToAddExtension: boolean;
    public SiteTaskId: number;
    public SiteTask: SiteTaskModel = new SiteTaskModel();
    public StartDateModel: any;
    public CurrentServerDate: Date;
    public ArchivedData: SiteTaskModel[];
    public IsArchived: boolean;
    public AccountId: number;
    public IsBimControl: boolean;
    public IsFileRequired: boolean;
    public Url: string
}
export class IntervalModel {
    public IntervalId: number;
    public Name: string;
    public IntervalType: number;
    public Value: number;
    public AccountId: number;
}
export class MainCategoryModel {
    public Id: number;
    public Name: string;
    public AccountId: number;
}
export class TaskMainCategoryModel {
    public Id: number;
    public MainCategoryId: number;
    public TaskId: number;
    public MainCategory: MainCategoryModel;
}
export class SubCategoryModel {
    public Id: number;
    public Name: string;
    public AccountId: number;
}
export class ActivityRoleModel {
    public Id: number;
    public Name: string;
    public AccountId: number;
}
export class TaskSubCategoryModel {
    public Id: number;
    public SubCategoryId: number;
    public TaskId: number;
    public SubCategory: SubCategoryModel;
}

export class SiteTaskModel {
    public Id: number;
    public SiteId: number;
    public TaskId: number;
    public PerformerId: number;
    public Performer: string;
    public StartDate: NgbDateStruct;
    public InfoRoles: string;
    public RoleName: string = "";
    public IsPublished: boolean;
    public isPublishing: boolean = false;
    public Users: any[] = [];
    public PublishDate: Date;
    public Site: SiteModel;
}

export class SiteTaskLogModel {

    public Id: number;
    public SiteTaskId: number;
    public Comment: string;
    public LogType: number;
    public Owner: string;
    public IntervalDate: Date;
    public ExtendDay: number;
    public loopConfirm: number;
    public Files: any[];
    public LogDate: Date;
    public LogDateOffset: number;
    public TaskNo: string;
    public Taskname: string;
    public IsBimControl: boolean;
    public Items: any[]; // todo: not implemented
}



// WEBPACK FOOTER //
// ./src/app/models/taskModel.ts